// src/components/GetInTouch/GetInTouchSection.tsx
import React from "react";
import { useInViewAnimation } from "../../utils/useInViewAnimation";
import "./getInTouch.css";

const GetInTouchSection: React.FC = () => {
  const sectionRef = useInViewAnimation("getintouch--visible", {
    threshold: 0.25,
    rootMargin: "0px 0px -120px 0px",
    once: true,
  });

  return (
    <section
      className="getintouch"
      ref={sectionRef as React.RefObject<HTMLElement>}
    >
      <div className="getintouch__background" />

      <div className="getintouch__wrapper">
        {/* LEFT */}
        <div className="getintouch__left animate-left">
          <span className="getintouch__badge">DESIGNING FOR THE FUTURE</span>

          <h2 className="getintouch__heading">
            Let’s Start Our Conversation
            <br />
            With a Simple Hello.
          </h2>

          <p className="getintouch__text">
            Share a bit about your idea or needs and we’ll get back to you quickly.
          </p>

          <div className="getintouch__points">
            <div className="point">Organizations and recognized work</div>
            <div className="point">
              <span className="tick">✓</span> Dedicated Tech Services
            </div>
            <div className="point">Industry-Ready Engineering Teams</div>
            <div className="point">
              <span className="tick">✓</span> End-to-End Project Delivery
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="getintouch__card animate-right">
          <button className="getintouch__pill">Contact Us</button>

          <h3 className="card__title">Get In Touch</h3>
          <p className="card__subtitle">
            If you wish to send us more info, head down to our contact section and
            share your idea.
          </p>

          <div className="card__info">
            <div>
              <label>Email</label>
              <p>info@noridcworks.com</p>
            </div>

            <div>
              <label>Phone</label>
              <p>+46 734 881 788</p>
            </div>

            <div>
              <label>Address</label>
              <p>
                Helsingörsgatan 51<br />
                Kista – 16444<br />
                Stockholm, Sweden
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInTouchSection;
